"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStruct = exports.readInteger = exports.ENDIANNESSES = exports.INTEGER_TYPES = void 0;
exports.INTEGER_TYPES = ['U8', 'I8', 'U16', 'I16', 'U32', 'I32'];
exports.ENDIANNESSES = ['LE', 'BE'];
function readInteger(data, pos, type, endianness = 'LE') {
    if (type === 'I8') {
        return data.getInt8(pos);
    }
    if (type === 'U8') {
        return data.getUint8(pos);
    }
    if (type === 'I16') {
        return data.getInt16(pos, endianness === 'LE');
    }
    if (type === 'U16') {
        return data.getUint16(pos, endianness === 'LE');
    }
    return data.getInt32(pos, endianness === 'LE');
}
exports.readInteger = readInteger;
function makeStruct(data, offset, structDef, endianness = 'LE') {
    let result = {};
    for (const [name, type] of structDef) {
        result[name] = readInteger(data, offset, type, endianness);
        if (type === 'U8' || type === 'I8') {
            offset += 1;
        }
        else if (type === 'U16' || type === 'I16') {
            offset += 2;
        }
        else if (type === 'U32' || type === 'I32') {
            offset += 4;
        }
    }
    return result;
}
exports.makeStruct = makeStruct;
